<template>
  <div class="avatar-container">
    <div class="avatar-name">
      <span>{{
        `${userInfo.name}(${
          userInfo.loginAccount ? userInfo.loginAccount : ''
        })`
      }}</span>
      <span class="avatar-name-icon" @click.stop="toggleUserMenus">
        <img src="@/assets/images/layout/icon_xiala@2x.png" />
        <div class="UserMenus" v-if="userMenusVisble">
          <div class="UserMenus-Link" @click="showUserinfoDialog">
            <span class="UserMenus-Link-icon">
              <img src="@/assets/images/layout/icon_ziliao.png" />
            </span>
            修改资料
          </div>
          <div class="UserMenus-Link" @click="cellphoneDialogVisible = true">
            <span class="UserMenus-Link-icon">
              <img src="@/assets/images/layout/icon_xiugai.png" />
            </span>
            修改手机号
          </div>
          <div
            v-if="userInfo.roles && ~userInfo.roles.indexOf('ACCOUNTS')"
            class="UserMenus-Link"
            @click="openUserAmount"
          >
            <span class="UserMenus-Link-icon">
              <img src="@/assets/images/layout/icon_xiugai.png" />
            </span>
            账户中心
          </div>
          <div class="UserMenus-Link" @click="logout">
            <span class="UserMenus-Link-icon">
              <img src="@/assets/images/layout/icon_tuichu.png" />
            </span>
            退出登录
          </div>
        </div>
      </span>
    </div>
    <TimeBox />

    <normal-dialog
      title="修改密码"
      :visible="dialogVisible"
      width="50%"
      :before-close="cancelPwdUpdate"
      :close-on-click-modal="!showSetPassword"
      :show-close="!showSetPassword"
    >
      <el-form :model="pwd" :rules="rules" ref="pwdForm">
        <el-form-item
          label="原密码"
          prop="oldPwd"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            v-model="pwd.oldPwd"
            placeholder="请输入原密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="newPwd"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            v-model="pwd.newPwd"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码规则" :label-width="formLabelWidth">
          大写字母、小写字母、数字、特殊字符，四选其三
        </el-form-item>
        <el-form-item
          label="重复新密码"
          prop="rePwd"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            v-model="pwd.rePwd"
            placeholder="请再输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <p class="setpwd-info" v-if="showSetPassword">
            原始密码登陆请务必修改密码
          </p>
        </el-form-item>
      </el-form>
      <span v-if="showSetPassword" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkPwdForm">确 定</el-button>
      </span>
      <span v-else slot="footer" class="dialog-footer">
        <el-button @click="resetPwdForm">取 消</el-button>
        <el-button type="primary" @click="checkPwdForm">确 定</el-button>
      </span>
    </normal-dialog>

    <normal-dialog
      title="修改资料"
      :visible="userInfoDialogVisible"
      width="600px"
      :before-close="cancelUserinfoUpdate"
      class="userForm"
    >
      <el-form label-width="120px">
        <el-form-item label="登录账户">{{
          userInfo.loginAccount
        }}</el-form-item>
        <el-form-item label="姓名">
          <!-- <el-input
            v-model="userForm.name"
            maxlength="20"
            placeholder="请输入姓名"
          ></el-input> -->
          {{ userInfo.name }}
        </el-form-item>
        <el-form-item label="运营商">{{ userInfo.operateName }}</el-form-item>
        <el-form-item label="手机号">{{ userInfo.cellphone }}</el-form-item>
        <el-form-item label="当前登录密码">
          <el-input
            v-model="userForm.pwd"
            :type="showPwd ? 'text' : 'password'"
            maxlength="20"
            placeholder="请输入当前登录密码"
          ></el-input>
          <div class="showPassword" @click="showPwd = !showPwd">
            <img v-if="showPwd" src="@/assets/images/layout/icon_sel@2x.png" />
            <img v-else src="@/assets/images/layout/icon_nor@2x.png" />
          </div>
        </el-form-item>
        <el-form-item label="设置新密码">
          <el-input
            v-model="userForm.newPwd"
            :type="showNewPwd ? 'text' : 'password'"
            maxlength="20"
            placeholder="请输入新密码"
          ></el-input>
          <div class="showPassword" @click="showNewPwd = !showNewPwd">
            <img
              v-if="showNewPwd"
              src="@/assets/images/layout/icon_sel@2x.png"
            />
            <img v-else src="@/assets/images/layout/icon_nor@2x.png" />
          </div>
        </el-form-item>
        <el-form-item label="密码规则">
          大写字母、小写字母、数字、特殊字符，四选其三
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input
            v-model="userForm.checkPwd"
            :type="showCheckPwd ? 'text' : 'password'"
            maxlength="20"
            placeholder="请再次输入新密码"
          ></el-input>
          <div class="showPassword" @click="showCheckPwd = !showCheckPwd">
            <img
              v-if="showCheckPwd"
              src="@/assets/images/layout/icon_sel@2x.png"
            />
            <img v-else src="@/assets/images/layout/icon_nor@2x.png" />
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button
          type="primary"
          @click="updateUserinfoHandle"
          :disabled="loading"
          >确定</el-button
        >
        <el-button @click="cancelUserinfoUpdate">取消</el-button>
      </div>
    </normal-dialog>

    <normal-dialog
      title="修改手机号"
      :visible="cellphoneDialogVisible"
      width="500px"
      :before-close="cancelCellphoneUpdate"
      class="cellphoneForm"
    >
      <el-form label-width="120px" v-loading="loading">
        <el-form-item label="登录账户">{{
          userInfo.loginAccount
        }}</el-form-item>
        <el-form-item label="姓名">{{ userInfo.name }}</el-form-item>
        <el-form-item label="运营商">{{ userInfo.operateName }}</el-form-item>
        <el-form-item label="手机号">{{ userInfo.cellphone }}</el-form-item>
        <el-form-item label="更换手机账户">
          <el-input
            v-model="cellphoneForm.cellphone"
            maxlength="11"
            placeholder="请输入更换手机账户"
          ></el-input>
        </el-form-item>
        <el-form-item label="输入验证码">
          <div class="vcode-wrap">
            <el-input
              v-model="cellphoneForm.vcode"
              maxlength="6"
              placeholder="验证码"
            ></el-input>
            <Vcode class="vcode-box" :cellphone="cellphoneForm.cellphone" />
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="updateCellphone" :disabled="loading"
          >确定</el-button
        >
        <el-button @click="cancelCellphoneUpdate">取消</el-button>
      </div>
    </normal-dialog>
    <normal-dialog
      title="账户中心"
      :before-close="cancelUserAmount"
      :visible="userAmountDialogVisible"
      width="60%"
    >
    <span class="conde">当前功能已经迁移至新页面,<span class="newP" @click="toN">点击立即前往</span></span>
    </normal-dialog>
    <normal-dialog
      title="提现申请"
      :before-close="cancelDrawApply"
      :visible="drawApplyDialogVisible"
      width="400px"
    >
      <el-form label-width="90px" v-loading="loading" label-position="left">
        <el-form-item label="到账卡号">
          <el-select v-model="drawApply.bankCardId" placeholder="请选择">
            <el-option
              v-for="item in banks"
              :key="item.id"
              :label="item.bankName + '(' + item.bankCardNo + ')'"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提现金额"
          ><div class="draw-money-box">
            {{ userAmount.drawAccounts.toFixed(2) }}元
          </div></el-form-item
        >
        <el-form-item label="实际到账"
          ><div class="actual-money-box">
            {{ (userAmount.drawAccounts - 1).toFixed(2) }}元
          </div></el-form-item
        >
        <div class="draw-tips">友情提示：每次提现将扣除1.00元手续费。</div>
        <el-form-item label="手续费"
          ><div class="fee-money-box">1.00元</div></el-form-item
        >

        <el-form-item label="备注">
          <el-input v-model="drawApply.summary"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doDrawApply" :disabled="loading"
          >提现</el-button
        >
        <el-button @click="cancelDrawApply">取消</el-button>
      </div>
    </normal-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TimeBox from './TimeBox';
// import CodeView from '../../login/components/CodeView';
import Vcode from './Vcode';
import { passwordValidate } from '../../../utils';
import listMixin from '../../../mixins/listPage';

import {
  allinPayBalanceSearchApi,
  allinPayBanksApi,
  allinPayDrawApplyApi,
  allinPayDrawPageListApi,
  getAccounts,
} from '../../../api/user/allinApi';

export default {
  components: {
    TimeBox,
    Vcode,
    // CodeView,
  },

  mixins: [listMixin],
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.pwd.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userMenusVisble: false,
      userInfoDialogVisible: false,
      cellphoneDialogVisible: false,
      userAmountDialogVisible: false,
      drawApplyDialogVisible: false,
      dialogVisible: false,
      vcodeVisible: false,
      accounts: [],
      formLabelWidth: '200px',
      receiverId: '',
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      dateRange: [],
      totalFee: 0,
      totalMoney: 0,
      pwd: {
        oldPwd: '',
        newPwd: '',
        rePwd: '',
      },
      rules: {
        oldPwd: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        rePwd: [
          { required: true, message: '请再输入新密码', trigger: 'blur' },
          { validator: validatePass },
        ],
      },
      userForm: {
        name: '',
        pwd: '',
        newPwd: '',
        checkPwd: '',
      },
      showPwd: false,
      showNewPwd: false,
      showCheckPwd: false,
      cellphoneForm: {
        cellphone: '',
        vcode: '',
        imgCode: '',
        svcode: '',
      },
      userAmount: {
        allAmounts: 0.0,
        drawAccounts: 0,
        freeZenAmounts: 0,
        unSettleAccounts: 0.0,
        canDraw: false,
      },
      drawApply: {
        bankCardId: null,
        summary: null,
      },
      banks: [],
      drawApplyPageList: [],
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'loading']),
    showSetPassword() {
      return this.userInfo && this.userInfo.isSetPassword === 0;
    },
  },
  mounted() {
    this.dialogVisible = this.showSetPassword;
  },
  watch: {
    userInfo(nVal) {
      if (nVal && nVal.isSetPassword === 0) {
        this.dialogVisible = true;
      }
    },
    receiverId(newV) {
      this.showA();
    },
  },
  methods: {
    ...mapActions([
      'updatePassword',
      'updateUserinfo',
      'updateUserCellphone',
      'drawApplyApi',
      'updatePagination',
    ]),
    changePage(index = 1) {
      this.updatePagination({
        pageNum: index,
        pageSize: this.paginationpageSize,
      });
      setTimeout(() => {
        this.getList();
      });
    },
    toN(){
      this.$router.push({ path: "/baseManage/allin/wallet"});
      this.userAmountDialogVisible = false;
    },
    // 分页大小改变时处理函数
    changeSizeHandle(pageSize) {
      this.pagination.pageSize = pageSize;
      setTimeout(() => {
        this.getList();
      });
    },
    toggleUserMenus() {
      this.userMenusVisble = !this.userMenusVisble;
      setTimeout(() => {
        if (this.userMenusVisble) {
          document.addEventListener('click', this.toggleUserMenus);
        } else {
          document.removeEventListener('click', this.toggleUserMenus);
        }
      }, 400);
    },
    cancelUserAccount() {
      this.accountVisible = false;
    },
    cancelPwdUpdate(done) {
      this.resetPwdForm();
      done();
    },
    resetPwdForm() {
      this.$refs.pwdForm.resetFields();
      this.dialogVisible = false;
    },
    checkPwdForm() {
      this.$refs.pwdForm.validate(valid => {
        if (valid) {
          if (this.pwd.newPwd.length < 6 || this.pwd.newPwd.length > 20) {
            this.$message.error('请输入6-20位密码');
            return;
          }
          if (!passwordValidate(this.pwd.newPwd)) {
            this.$message.error('请输入大小写字母数字符号组合密码');
            return;
          }
          this.updatePassword(this.pwd)
            .then(() => {
              this.$message.success('修改密码成功!');
              this.resetPwdForm();
            })
            .catch(err => {
              console.error(err);
              // this.$message.error('修改密码失败!');
            });
        }
      });
    },
    logout() {
      this.$store.dispatch('FedLogOut').then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    showUserinfoDialog() {
      this.userForm = {
        name: this.userInfo.name,
        pwd: '',
        newPwd: '',
        checkPwd: '',
      };
      this.userInfoDialogVisible = true;
    },
    cancelUserinfoUpdate(done) {
      this.resetUserForm();
      typeof done === 'function' && done();
    },
    resetUserForm() {
      this.userForm = {
        name: '',
        pwd: '',
        newPwd: '',
        checkPwd: '',
      };
      this.userInfoDialogVisible = false;
    },
    validateUserForm() {
      if (!this.userForm.name) {
        this.$message.error('请输入姓名');
        return;
      }
      if (this.userForm.newPwd) {
        if (!this.userForm.pwd) {
          this.$message.error('请输入密码');
          return;
        }
        if (
          this.userForm.newPwd.length < 6 ||
          this.userForm.newPwd.length > 20
        ) {
          this.$message.error('请输入6-20位密码');
          return;
        }
        if (!passwordValidate(this.userForm.newPwd)) {
          this.$message.error('请输入大小写字母数字符号组合密码');
          return;
        }
        if (!this.userForm.checkPwd) {
          this.$message.error('请再次输入新密码');
          return;
        }
        if (this.userForm.newPwd !== this.userForm.checkPwd) {
          this.$message.error('两次输入密码不一致');
          return;
        }
      }
      return true;
    },
    updateUserinfoHandle() {
      if (this.validateUserForm()) {
        const entity = this.userForm.newPwd
          ? {
              name: this.userForm.name,
              newPwd: this.userForm.newPwd,
              oldPwd: this.userForm.pwd,
            }
          : {
              name: this.userForm.name,
            };
        this.updateUserinfo(entity)
          .then(res => {
            this.$message.success(res.msg || '修改成功');
            this.cancelUserinfoUpdate();
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    cancelCellphoneUpdate(done) {
      this.resetCellphoneForm();
      typeof done === 'function' && done();
    },
    resetCellphoneForm() {
      this.cellphoneForm = {
        cellphone: '',
        vcode: '',
        svcode: '',
      };
      this.cellphoneDialogVisible = false;
    },
    openUserAmount() {
      getAccounts().then(res => {
        this.userAmountDialogVisible = true;
        this.accounts = res.data || [];
        if (res.data && res.data.length > 0) {
          this.receiverId = res.data[0].receiverId;
        }
      });
    },
    showA() {
      this.accountVisible = false;
      if (!this.receiverId) {
        return;
      }
      allinPayBalanceSearchApi({
        receiverId: this.receiverId,
      })
        .then(res => {
          this.userAmount = res.data;
          this.userAmountDialogVisible = true;
          this.getList();
        })
        .catch(err => {
          console.error(err);
        });
    },
    getList() {
      let fil = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        receiverId: this.receiverId,
      };
      if (this.dateRange && this.dateRange.length ==2&&this.dateRange[0]&&this.dateRange[1]) {
        fil.startDate = this.dateRange[0].substring(0, 10);
        fil.endDate = this.dateRange[1].substring(0, 10);
      }
      allinPayDrawPageListApi(fil).then(res => {
        let { list, ...pagination } = res.data;
        this.drawApplyPageList = list;
        let totalMoney = 0,
          totalFee = 0;
        list.forEach(item => {
          totalFee += item.fee ? item.fee : 0;
          totalMoney += item.money ? item.money : 0;
        });
        this.totalFee = totalFee.toFixed(2);
        this.totalMoney = totalMoney.toFixed(2);
        this.pagination = { ...pagination };
      });
    },
    cancelUserAmount(done) {
      this.userAmountDialogVisible = false;
      this.receiverId = '';
      typeof done === 'function' && done();
    },
    openDrawApply() {
      if (!this.receiverId) {
        return;
      }
      allinPayBanksApi({ receiverId: this.receiverId })
        .then(res => {
          this.banks = res.data;
          this.drawApply.bankCardId = res.data[0].id;
          this.drawApplyDialogVisible = true;
        })
        .catch(err => {
          console.error(err);
        });
    },
    cancelDrawApply(done) {
      this.drawApplyDialogVisible = false;
      typeof done === 'function' && done();
    },
    doDrawApply() {
      allinPayDrawApplyApi({
        ...this.drawApply,
        receiverId: this.receiverId,
      }).then(res => {
        this.$message.success(res.msg);
      });
    },
    validateCellphoneForm() {
      if (!this.cellphoneForm.cellphone) {
        this.$message.error('请输入更换手机号');
        return false;
      }
      if (!this.cellphoneForm.vcode) {
        this.$message.error('请输入验证码');
        return false;
      }

      return true;
    },
    updateCellphone() {
      if (this.validateCellphoneForm()) {
        const entity = {
          cellphone: this.cellphoneForm.cellphone,
          checkCode: this.cellphoneForm.vcode,
        };
        this.updateUserCellphone(entity)
          .then(res => {
            this.resetCellphoneForm();
            this.$message.success(res.msg || '修改成功');
            this.cancelCellphoneUpdate();
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables.scss';
.setLine {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.avatar-container {
  margin-left: 15px;
  display: flex;
  align-items: center;
  color: #fff;
  line-height: 22px;
  font-size: 12px;
  flex: 1;
  .avatar-container-line {
    margin: 0 20px;
  }
  .avatar-name {
    display: flex;
    align-items: center;
    line-height: 20px;
    font-size: 14px;
    width: 213px;
    margin-right: 10px;
    .avatar-name-icon {
      position: relative;
      margin-left: 6px;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
    .UserMenus {
      position: absolute;
      z-index: 1000;
      top: 20px;
      right: -10px;
      width: 148px;
      background-color: #68aaff;
      border-radius: 8px;
      font-size: 14px;
      overflow: hidden;
      .UserMenus-Link {
        cursor: pointer;
        height: 30px;
        line-height: 30px;
        display: flex;
        align-items: center;
        .UserMenus-Link-icon {
          width: 12px;
          height: 12px;
          margin: 0 10px 0;
        }
      }
      .UserMenus-Link:hover {
        background-color: #0d48d4;
      }
    }
  }
  .avatar-quit {
    cursor: pointer;
    font-size: 10px;
    line-height: 24px;
    .avatar-quit-icon {
      display: inline-block;
      margin-left: 10px;
      margin-top: -2px;
      width: 20px;
      height: 18px;
      vertical-align: middle;
    }
  }
  .avatar-wrapper {
    cursor: pointer;
    color: #a0acb9;
    position: relative;
    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 10px;
    }
    .el-icon-caret-bottom {
      position: absolute;
      right: -18px;
      top: 6px;
      font-size: 12px;
    }
  }
  .setpwd-info {
    color: red;
  }
  .userForm {
    .el-form-item {
      margin-bottom: 12px;
    }
  }
  .cellphoneForm {
    .vcode-wrap {
      display: flex;
      align-items: center;
    }
    .el-input {
      flex: 1;
    }
    .vcode-box {
      width: 100px;
      text-align: center;
      cursor: pointer;
      color: $menuHover;
    }
  }
  .showPassword {
    position: absolute;
    top: 15px;
    right: 10px;
    width: 20px;
    height: 12px;
  }

  .user-amount {
    margin-bottom: 20px;
  }

  .draw-tips {
    color: red;
  }

  .draw-money-box {
    width: 100%;
    text-align: right;
  }

  .actual-money-box {
    width: 100%;
    text-align: right;
    color: green;
  }

  .fee-money-box {
    width: 100%;
    text-align: right;
    color: red;
  }
}
.img-code-box {
  display: flex;
  align-items: center;
  .code-img {
    width: 80px;
    height: 32px;
    margin-left: 20px;
  }
}
.newP{
  color: #0d48d4;
  text-decoration: underline;
  
}
.conde{
  color: red;
  font-size: 24px;
  letter-spacing: 5px;
}
.newP:hover{
  cursor: pointer;
}
@media screen and (min-width: $bigScreenWidth) {
  .avatar-container {
    font-size: 18px;
    .avatar-name {
      line-height: 30px;
      font-size: 24px;
      .UserMenus {
        font-size: 18px;
        top: 35px;
        .UserMenus-Link {
          height: 46px;
          line-height: 46px;
          .UserMenus-Link-icon {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
    .avatar-quit {
      font-size: 14px;
    }
  }
}
.setC {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
</style>
